import SiteBase from "./siteBase";

const ProviderSite = () => {
  return (
    <SiteBase patientSite={false}/>
  );
}

export default ProviderSite;